module.exports = __webpack_public_path__ + "static/media/SOLID-SLATE-LOGO-01.88c405c4.svg";